<!--
  UIID: UI-Caas-MON-100
  UI Name: Monitoring List
  Modify Date: 2020/06/16
-->
<template>
  <div class="container monitoring-list-container">
    <!-- Header -->
    <v-row class="page-header">
      <v-col class="page-title" cols="12">
        <v-toolbar-title :class="['font-bold', $vuetify.theme.dark ? '' : 'black--text']">
          {{ $t('lbl.monitoring.page_header') }}
        </v-toolbar-title>
      </v-col>
    </v-row>

    <!-- Condition search -->
    <v-row
      class="mb-0 custom-form-control custom-form-control-type-2 custom-form-control-type-4 custom-figma-1"
    >
      <v-col cols="12" class="search-conditions-display">
        <div class="pl-0 pt-0 pb-0 collapse-search-conditions hide">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('collapse')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-up</v-icon>
            {{ $t('btn.common.collapseConditions') }}
          </v-btn>
        </div>
        <div class="pl-0 pt-0 pb-0 expand-search-conditions">
          <v-btn
            class="btn btn-top"
            color="primary"
            @click.native="displaySearchConditions('expand')"
          >
            <v-icon x-small class="mr-2">fa fa-chevron-down</v-icon>
            {{ $t('btn.common.expandConditions') }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" xl="8" lg="8" md="12">
        <v-row>
          <!-- //06/07/2021 203737 SPKA-134 Change all text field and combo box style in all search result -->
          <v-col
            cols="12"
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
          >
            <v-row class="pt-0 pb-0 mt-0 mb-2">
              <v-col
                v-show="$cookies.get('user-admin-yn') === 'Y'"
                cols="12"
                lg="2"
                md="4"
                class="pt-0 pb-0 mb-0"
              >
                <!-- <div class="d-inline-flex-2 area-btn">
                    <v-btn
                      class="btn btn-add btn-arrow color-figma-1" 
                      @click="show = !show"
                      icon
                      small>
                      <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                </div>-->
                <!-- 05/17/2021 203737 SPKA-108 issue 60 Modify to display the company combo in popup when only comp_info.sp_flag = 'Y' -->
                <!-- 
                  06/07/2021 203737 SPKA-134 Change all text field and combo box style in all search result
                  Add props filled for text field and combobox
                -->
                <div class="d-inline-flex-2 area-condition">
                  <v-autocomplete
                    v-model="company"
                    :label="$t('lbl.common.conditionSearch.selectCompany')"
                    :items="customerItem"
                    @change="initialize"
                    width="60px"
                    dense
                    filled
                    hide-details
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col
                cols="12"
                :lg="$cookies.get('user-admin-yn') === 'Y' ? '2' : '3'"
                md="4"
                class="pt-0 pb-0 pr-0"
              >
                <v-text-field
                  v-model="senderId"
                  :label="$t('lbl.common.conditionSearch.findbySender')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                :lg="$cookies.get('user-admin-yn') === 'Y' ? '2' : '3'"
                md="4"
                class="pt-0 pb-0 pr-24px"
              >
                <v-text-field
                  v-model="recipientId"
                  :label="$t('lbl.common.conditionSearch.findbyReceiver')"
                  @keyup.enter="initialize"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="message"
                  :items="EDIMesList"
                  :label="$t('lbl.common.conditionSearch.selectMessage')"
                  @change="changeMsgCode"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="direction"
                  :label="$t('lbl.common.conditionSearch.selectDirection')"
                  :items="directions"
                  @change="initialize"
                  class="custom-selectbox"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="2" md="4" class="pt-0 pb-0">
                <v-autocomplete
                  v-model="status"
                  dense
                  class="custom-selectbox"
                  :label="$t('lbl.common.conditionSearch.selectStatus')"
                  :items="statuses"
                  @change="initialize"
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" xl="4" lg="4" md="12">
        <v-row>
          <v-col
            class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
          >
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromdate_menu"
                v-model="fromDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('from', $event)"
                    @change="changeDate('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="fromDateData"
                  :disabled="!dateCond"
                  :max="getMaxDate"
                  @input="
                    fromDate = false;
                    changeDate('from');
                  "
                  class="date-period-picker"
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromdate_menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.fromdate_menu.save(fromDateData)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="fromtime_menu"
                v-model="fromTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fromTimeData"
                    :disabled="!dateCond"
                    :class="['time-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('from', $event)"
                    @change="validateTimeInput('from')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :disabled="!dateCond"
                  v-model="fromTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="fromtime_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.fromtime_menu.save(fromTimeData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="todate_menu"
                v-model="toDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toDateData"
                    :disabled="!dateCond"
                    :class="['date-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-calendar"
                    dense
                    solo
                    @keypress="formatDate('to', $event)"
                    @change="changeDate('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-date-picker
                  class="date-period-picker"
                  :allowed-dates="allowedDates"
                  v-model="toDateData"
                  :disabled="!dateCond"
                  @input="
                    toDate = false;
                    changeDate('to');
                  "
                  no-title
                  scrollable
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="todate_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.todate_menu.save(toDateData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-menu
                ref="totime_menu"
                v-model="toTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="toTimeData"
                    :disabled="!dateCond"
                    :class="['time-text', $vuetify.theme.dark ? '' : 'font-semibold']"
                    append-icon="mdi-clock-outline"
                    dense
                    solo
                    @keypress="formatTime('to', $event)"
                    @change="validateTimeInput('to')"
                    @click:append="on.click"
                  ></v-text-field>
                </template>
                <v-time-picker
                  :disabled="!dateCond"
                  v-model="toTimeData"
                  class="time-picker"
                  scrollable
                  format="ampm"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="totime_menu = false">{{
                    $t('btn.common.cancel')
                  }}</v-btn>
                  <v-btn text color="primary" @click="$refs.totime_menu.save(toTimeData)">{{
                    $t('btn.common.ok')
                  }}</v-btn>
                </v-time-picker>
              </v-menu>
            </div>
            <div class="pl-0 pt-0 pb-0 d-inline-flex">
              <v-btn
                class="btn-width-1 btn btn-top btn-search"
                color="primary"
                @click.native="initialize"
              >
                <v-icon x-small class="mr-2">fa fa-search</v-icon>
                {{ $t('btn.common.search') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
        cols="12"
        lg="12"
        md="12"
      >
        <v-row class="pt-0 pb-0 mt-0 mb-4">
          <v-col cols="12" xl="4" lg="4" class="flex pt-0 pb-0">
            <v-row class="pr-0">
              <v-col
                cols="4"
                class="pt-0 pb-0"
                :style="[$vuetify.theme.dark ? 'padding-right: 1px' : 'margin-right: -1px']"
              >
                <v-autocomplete
                  v-model="searchKeyBy1"
                  :class="['custom-selectbox', $vuetify.theme.dark ? '' : 'font-semibold']"
                  :label="
                    $vuetify.theme.dark ? $t('lbl.common.conditionSearch.selectSearchKey') : ''
                  "
                  :items="searchKeyByItems"
                  @change="changeKeyBy"
                  dense
                  filled
                  hide-details
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="8"
                class="flex pl-0 pt-0 pb-0"
                :style="[$vuetify.theme.dark ? 'gap: 1px' : '']"
              >
                <div class="flex pl-0" :style="$vuetify.theme.dark ? '' : 'margin-left: -2px'">
                  <div class="flex flex-1" :style="$vuetify.theme.dark ? 'padding-right: 1px' : ''">
                    <v-combobox
                      class="input-field-chips"
                      v-model="chips1"
                      multiple
                      small-chips
                      solo
                    >
                      <template v-slot:selection="{ item, index }">
                        <v-chip close @click:close="removeChip(chips1, index)" class="ma-1">
                          {{ item }}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </div>
                  <!-- <v-text-field
                  v-model="searchKeyByTxt1"
                  :label="$t('lbl.common.conditionSearch.inputSearchKey')"
                  @click:append="openInputSearchKeyWindow()"
                  v-on:keyup.enter="initialize"
                  dense
                  filled
                  hide-details
                ></v-text-field> -->
                  <div class="filter-icon-add" @click="openAddFilter()">
                    <icon-svg
                      :size="18"
                      :stroke="$vuetify.theme.dark ? '#D8D8D8' : '#6F90AF'"
                      iconName="filter-add"
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="8" xl="8" lg="8" class="flex pt-0 pb-0">
            <v-row>
              <v-col v-if="isAddFilter" cols="4" class="pt-0 pb-0">
                <div class="flex pt-0" style="gap: 1px">
                  <div :style="[$vuetify.theme.dark ? 'padding-right: 1px' : 'margin-right: -1px']">
                    <v-autocomplete
                      v-model="searchKeyBy2"
                      :class="['custom-selectbox', $vuetify.theme.dark ? '' : 'font-semibold']"
                      :label="
                        $vuetify.theme.dark ? $t('lbl.common.conditionSearch.selectSearchKey') : ''
                      "
                      :items="searchKeyByItems"
                      @change="changeKeyBy"
                      dense
                      filled
                      hide-details
                    ></v-autocomplete>
                  </div>
                  <div class="flex pl-0" :style="$vuetify.theme.dark ? '' : 'margin-left: -2px'">
                    <div
                      class="flex flex-1"
                      :style="$vuetify.theme.dark ? 'padding-right: 1px' : ''"
                    >
                      <v-combobox
                        class="input-field-chips"
                        v-model="chips2"
                        multiple
                        chips
                        solo
                        hide-no-data
                        no-filter
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip close @click:close="removeChip(chips2, index)" class="ma-1">
                            {{ item }}
                          </v-chip>
                        </template>
                      </v-combobox>
                    </div>
                    <!-- <v-text-field
                      style="padding-right: 1px;"
                      v-model="searchKeyByTxt2"
                      :label="$t('lbl.common.conditionSearch.inputSearchKey')"
                      @click:append="openInputSearchKeyWindow()"
                      v-on:keyup.enter="initialize"
                      dense
                      filled
                      hide-details
                    ></v-text-field> -->
                    <div class="filter-icon-add" @click="deleteAddFilter()">
                      <icon-svg
                        :size="18"
                        :stroke="$vuetify.theme.dark ? '#D8D8D8' : '#6F90AF'"
                        iconName="delete-new"
                      />
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col cols="8" class="pt-0 pb-0">
                <v-row>
                  <v-col cols="6" class="pt-0 pb-0">
                    <div class="mr-2" style="min-width: 420px">
                      <v-autocomplete
                        v-model="processSetupId"
                        class="custom-selectbox"
                        :label="$t('lbl.common.conditionSearch.selectSetUpName')"
                        :items="getProcessSetupNameList"
                        @change="initialize"
                        dense
                        filled
                        hide-details
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="6" class="flex align-center">
                    <div class="pl-0 pt-0 pb-0 flex justify-center code-table-section">
                      <v-checkbox
                        v-model="dateCond"
                        :disabled="checkSearchKeyBy"
                        :style="[$vuetify.theme.dark ? '' : 'border: none;']"
                        class="mt-0 pt-0"
                        hide-details
                        @change="changeDateTime"
                        dense
                        solo
                      ></v-checkbox>
                      <span
                        class="all-code-label ml-4"
                        style="position: relative;top: -2px;left: -12px;"
                        >{{ $t('msg.common.applyDateCond') }}</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="pt-0 pb-0 mb-0"></v-col>
    </v-row>
    <!-- Condition search -->
    <!-- Grid table page class="flat-file-control-section" -->
    <v-row class="custom-pagination-figma-v3-first">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="8" md="7">
            <v-row>
              <v-col class="page-control-bg" cols="9">
                <v-btn
                  @click="downloadExcel"
                  :disabled="!$auth.manage"
                  x-small
                  class="btn-height-custom btn-excel mb-0"
                >
                  <!-- <v-icon x-small class="mr-2">fas fa-file-excel</v-icon> -->
                  {{ $t('btn.monitoring.excel') }}
                </v-btn>
                <v-btn
                  @click="downOriginMulti"
                  :disabled="
                    !$auth.manage ||
                      Number($cookies.get('use-grade')) !== 9 ||
                      !selectItems.length > 0
                  "
                  x-small
                  class="btn-height-custom btn-excel mb-0"
                >
                  {{ $t('btn.monitoring.originFiles') }}
                </v-btn>
              </v-col>
              <!-- !$auth.manage -->
              <v-col cols="3" class="page-control-bg text-right mr-0 pr-0">
                <v-btn
                  @click="reProcesMulti"
                  :disabled="
                    !$auth.manage || Number($cookies.get('use-grade')) !== 9 || checkReprocess
                  "
                  x-small
                  class="btn-height-custom btn-add mb-0 mr-0"
                >
                  {{ $t('btn.monitoring.reMulti') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <!-- <v-col lg="2" md="0"></v-col> -->
          <v-col lg="4" md="5" class="filter-search">
            <v-row>
              <v-col class="mr-0 pr-0" md="5">
                <v-select
                  v-model="searchBy"
                  :placeholder="$t('lbl.common.searchTypePlaceHolder')"
                  height="40"
                  hide-details
                  dense
                  solo
                  @change="onFilterTransactionLog"
                  :items="searchByItems"
                  class="search-by data-table-select-box custom-selectbox flat-file-selectbox mr-0"
                ></v-select>
              </v-col>
              <v-col class="ml-0 pl-0" cols="12" md="7">
                <v-text-field
                  v-model="searchByTxt"
                  heigth="40"
                  append-icon="fa fa-search"
                  :placeholder="$t('lbl.common.searchPlaceHolder')"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field search-button-data-analysis-table flat-file"
                  @input="onFilterTransactionLog"
                  @click:append="onFilterTransactionLog"
                  v-on:keyup.enter="onFilterTransactionLog"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Table content -->
    <v-row>
      <!-- // 203737 05/10/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <!-- // 2021.7.27 203728 SPKA-162 Change v-data-table to v-table -->
        <v-table
          ref="srm_list_table"
          :height="tableHeight"
          :columns="columns"
          :table-data="listData"
          :title-row-height="$vuetify.theme.dark ? 45 : 41"
          :row-height="35"
          :class="
            $vuetify.theme.dark
              ? 'v-search-list-table-merge srm-list-table repo-list-table custom-figma-1'
              : 'v-search-list-table-merge srm-list-table repo-list-table'
          "
          :errorContent="'No matching records found'"
          :border-header-height="$vuetify.theme.dark ? 0 : 4"
          is-horizontal-resize
          is-vertical-resize
          width="100%"
          :paging-index="(page - 1) * itemsPerPage"
          :multiple-sort="false"
          @sort-change="sortChange"
          :row-mouse-enter="rowEnter"
          :row-mouse-leave="rowLeave"
          :row-click="rowClick"
          :select-all="selectAll"
          :select-change="selectChange"
          :show-horizontal-border="$vuetify.theme.dark ? true : false"
        >
          <template v-slot:INDEX="{ item }">
            <div class="index-col">{{ item.INDEX }}</div>
          </template>
          <template v-slot:senderId="{ item }">
            <font class="pl-2 sender-col">{{ item.record.messageInfo.senderId }}</font>
          </template>
          <template v-slot:recipientId="{ item }">
            <font class="pl-2 receiver-col">{{ item.record.messageInfo.recipientId }}</font>
          </template>
          <template v-slot:messageName="{ item }">
            <font class="pl-2 message-col">{{ item.record.messageInfo.messageName }}</font>
          </template>
          <template v-slot:processSetupName="{ item }">
            <a class="link-file-text cursor-pointer" @click="openProcessWindow(item)">
              <u>{{ item.processSetupName }}</u>
            </a>
          </template>
          <template v-slot:direction="{ item }">
            <font>{{ directionText(item.direction) }}</font>
          </template>
          <template v-slot:transactionCode="{ item }">
            <font
              v-if="item.transactionCode.indexOf('FAIL') !== -1"
              class="cursor-pointer font-semibold"
              :color="statusColor(item.transactionCode, item.processCode)"
              @click="openMonitoringStateViewWindow(item)"
              >{{ statusText(item.transactionCode, item.reprocessState, item.processCode) }}</font
            >
            <font
              v-else
              class="cursor-pointer font-semibold"
              :color="statusColor(item.transactionCode, item.processCode)"
              @click="openMonitoringStateViewWindow(item)"
              >{{ statusText(item.transactionCode, item.reprocessState, item.processCode) }}</font
            >
          </template>
          <template v-slot:fileLink="{ item }">
            <a
              v-if="item.record.transInput !== undefined && item.record.transOutput !== undefined"
              class="link-file-text cursor-pointer layout-col"
              @click="openMonitoringFileViewWindow(item)"
              >{{ $t('btn.common.view') }}</a
            >
          </template>
          <template v-slot:bizFileBackupId="{ item }">
            <a
              v-if="item.record.transOutput.bizFileBackupId !== ''"
              class="link-file-text cursor-pointer layout-col"
              @click="
                openMonitoringBizFileViewWindow(item.record.transOutput.bizFileBackupId, item)
              "
              >{{ $t('btn.common.view') }}</a
            >
          </template>
          <!-- 2022.04.15 213960 SPKA-444 Add column in Search result of Transaction Log -->
          <template v-slot:recvTimestamp="{ item }">
            <font v-if="item.record.transOutput !== undefined">{{
              applyGmtTimeZone(item.record.recvTimestamp)
            }}</font>
          </template>
          <template v-slot:transTimestamp="{ item }">
            <font v-if="item.record.transOutput !== undefined">{{
              applyGmtTimeZone(item.record.transTimestamp)
            }}</font>
          </template>
          <template v-slot:sentTimestamp="{ item }">
            <font v-if="item.record.transOutput !== undefined">{{
              applyGmtTimeZone(item.record.sentTimestamp)
            }}</font>
          </template>
          <template v-slot:searchKeyValue1="{ item }">
            <font>{{ item.record.searchKeyValue1 }}</font>
          </template>
          <template v-slot:searchKeyValue2="{ item }">
            <font>{{ item.record.searchKeyValue2 }}</font>
          </template>
          <template v-slot:referenceNo="{ item }">
            <font>{{ item.record.referenceNo }}</font>
          </template>
          <template v-slot:transInputSize="{ item }">
            <font>{{ item.record.transInput.fileSize }}</font>
          </template>
          <template v-slot:transOutputSize="{ item }">
            <font>{{ item.record.transOutput.fileSize }}</font>
          </template>
          <template v-slot:sourceFileName="{ item }">
            <font>{{ item.record.sourceFileName }}</font>
          </template>
          <template v-slot:targetFileName="{ item }">
            <font>{{ item.record.targetFileName }}</font>
          </template>
        </v-table>
      </v-col>
    </v-row>
    <!-- 2021.11.23 203728 SPKA-260 hidden if no records -->
    <v-row v-show="this.$store.getters.totalCnt > 0" class="custom-pagination-figma-v3-last">
      <v-col class="page-control-content page-control-bg transaction-pagi">
        <v-row>
          <v-col lg="12" md="12">
            <v-row>
              <v-col class="page-control-bg text-left pa-0" cols="6">
                <!-- 203665 Fix issue 19 commons Update pagination by server  -->
                <div class="custom-pagi-selectbox">
                  <v-select
                    @change="handlePageSizeChange"
                    v-model="itemsPerPage"
                    hide-details
                    dense
                    solo
                    :items="rowPerPage"
                    class="data-table-select-box custom-selectbox mr-0 page-flat-file-selectbox"
                  ></v-select>
                </div>
              </v-col>
              <v-col class="page-control-bg text-right pa-0" cols="6">
                <div class="page-showing">
                  <v-label
                    >{{ itemsPerPage * (page - 1) + 1 }} ~
                    {{ itemsPerPage * (page - 1) + listData.length }} of
                    {{ this.$store.getters.totalCnt }}</v-label
                  >
                </div>
                <!-- 2021.11.23 203728 SPKA-260 first prev button -->
                <button
                  type="button"
                  @click="handlePageChange(1)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == 1
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-backward"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="changePageByTextbox(-1)"
                  :class="[
                    'mr-3 custom-btn-first-last-paging',
                    page - 1 < 1
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="ml-2 pr-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-left"></i>
                    </span>
                  </div>
                </button>
                <!-- 2021.11.23 203728 SPKA-260 hidden input page number -->
                <v-text-field
                  v-model="pageEnter"
                  hide-details
                  dense
                  solo
                  class="data-table-filter-text-field custom-pagi-selectbox page-selectbox"
                  @keyup.enter="changePageByTextbox(0)"
                ></v-text-field>
                <label>/ {{ pageCount }}</label>
                <!-- 2021.11.23 203728 SPKA-260 hidden next last button -->
                <button
                  type="button"
                  @click="changePageByTextbox(1)"
                  :class="[
                    'ml-3 custom-btn-first-last-paging',
                    page + 1 > pageCount
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-lg fa-caret-right"></i>
                    </span>
                  </div>
                </button>
                <button
                  type="button"
                  @click="handlePageChange(pageCount)"
                  :class="[
                    'custom-btn-first-last-paging',
                    page == pageCount
                      ? ' v-pagination__navigation--disabled'
                      : `${$vuetify.theme.dark ? '' : 'white'}`,
                  ]"
                >
                  <div class="mr-2 pl-2 d-inline">
                    <span>
                      <i class="fa fa-sm fa-step-forward"></i>
                    </span>
                  </div>
                </button>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <monitoringBizFileViewWindow
        v-if="dialog.type == 'monitoringBizFileViewWindow'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :fileViewInfo="tempItem"
        :outputBizFileLink="tmpOutputBizFileLink"
      ></monitoringBizFileViewWindow>
      <inputSearchKeyWindow
        v-if="dialog.type == 'inputSearchKeyWindow'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :searchKeyVal="tempItem"
        @select-ok="setSearchKeyByTxt($event)"
      ></inputSearchKeyWindow>
    </div>
    <dialogWindow
      ref="Validation"
      :info="checkDialogTitle"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    ></dialogWindow>
    <dialogWindow
      ref="excelValidation"
      size="max"
      :detail="excelWarningContent"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="reProcess"
      size="max"
      :detail="reProcessContent"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail="$t('msg.common.validateDate')"
      color="validation"
    ></dialogWindow>
    <!-- <dialogWindow
      ref="checkallowPopup"
      size="max"
      :detail="$t('msg.common.contentAllowPopup')"
      :showCheckbox="true"
      @checkboxValue="checkboxValue"
      :checkboxLabel="$t('msg.common.lableAllowPopup')"
      @select-ok="checkPopupCookie()"
      @valueCB="changeCookie($event)"
    ></dialogWindow> -->
  </div>
</template>

<script>
import monitoringBizFileViewWindow from '@/vue-caas/views/monitoring/MonitoringBizFileView.vue';
import inputSearchKeyWindow from '@/vue-caas/views/monitoring/InputSearchKeyView.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { deleteDateFormatStr } from '@/vue-dlb/utils/util';
import { getAppliedTimeZone } from '@/vue-dlb/utils/util';
import { dateValidation } from '@/vue-dlb/utils/util';
import config from '@/vue-caas/config/config.js';
import { mapState } from 'vuex';
import $ from 'jquery';
import { resizeTableHeight } from '@/vue-dlb/common/common';
import { openWindow } from '@/vue-dlb/utils/window-opener';
import IconSvg from '@/vue-caas/components/IconBase.vue';

import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
const moment = require('moment');

export default {
  components: {
    monitoringBizFileViewWindow,
    inputSearchKeyWindow,
    dialogWindow,
    SystemProgress,
    IconSvg,
  },

  data() {
    return {
      chips1: [],
      chips2: [],
      // checkboxValue: false,
      dateCond: true,
      checkSearchKeyBy: false,
      tableHeight: 635,
      isCreated: false,
      dateTimeFormat: '',
      dialogFileView: false,
      dialogErrView: false,
      dialogs: [],
      dialogId: 1,
      dialog: false,
      arrLayoutDialog: [],
      // 2021.7.27 203728 SPKA-162 Change v-data-table to v-table
      columns: [
        {
          field: 'custome',
          width: 47,
          customSlot: true,
          checkShow: true,
          isShowSelect: (item) => {
            return item;
          },
          titleAlign: 'center',
          columnAlign: 'center',
          type: 'selection',
          isFrozen: true,
        },
        {
          field: 'INDEX',
          title: this.$t('tbl.common.columnNo'),
          width: 60,
          columnAlign: 'center',
          titleAlign: 'center',
          className: 'frozen-col-bg',
          isFrozen: true,
          customSlot: true,
        },
        {
          field: 'senderId',
          title: 'Sender',
          width: 110,
          columnAlign: 'left',
          titleAlign: 'center',
          className: 'frozen-col-bg',
          isFrozen: true,
          customSlot: true,
        },
        {
          field: 'recipientId',
          title: 'Receiver',
          width: 110,
          columnAlign: 'left',
          titleAlign: 'center',
          className: 'frozen-col-bg',
          isFrozen: true,
          customSlot: true,
        },
        {
          field: 'messageName',
          title: 'Message',
          width: 110,
          columnAlign: 'left',
          titleAlign: 'center',
          className: 'frozen-col-bg',
          isFrozen: true,
          customSlot: true,
        },
        // { field: "partnerName", width: 120, columnAlign: "left" },
        {
          field: 'direction',
          title: 'Direction',
          width: 120,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        {
          field: 'transactionCode',
          title: 'Status',
          width: 120,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        // 2022.04.15 213960 SPKA-444 Add column in Search result of Transaction Log
        {
          field: 'recvTimestamp',
          title: 'Received Date',
          width: 180,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        {
          field: 'transTimestamp',
          title: 'Translation Date',
          width: 180,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        {
          field: 'sentTimestamp',
          title: 'Sent Date',
          width: 180,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        {
          field: 'fileLink',
          title: 'Processed File',
          width: 140,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        // 2021.11.5 203728 SPKA-245 2. Increase column with in result grid. - Process ID --> 230px - Search Key Value --> 250px
        {
          field: 'processId',
          title: 'Process ID',
          width: 230,
          columnAlign: 'center',
          titleAlign: 'center',
        },
        {
          field: 'searchKeyValue1',
          title: 'Search Key Value 1',
          width: 250,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        {
          field: 'searchKeyValue2',
          title: 'Search Key Value 2',
          width: 250,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        {
          field: 'transInputSize',
          title: 'Source File Size',
          width: 110,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        {
          field: 'transOutputSize',
          title: 'Target File Size',
          width: 110,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        this.$cookies.get('user-admin-yn') === 'Y' && {
          field: 'processSetupName',
          title: 'Setup Name',
          width: 260,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
          isResize: true,
        },
        {
          field: 'bizFileBackupId',
          title: 'Biz. File',
          width: 100,
          columnAlign: 'center',
          titleAlign: 'center',
          customSlot: true,
        },
        // 2021.11.5 203728 SPKA-245 4. change align left : "Input File Name", "Output File Name"
        {
          field: 'sourceFileName',
          title: 'Input File Name',
          width: 700,
          columnAlign: 'left',
          titleAlign: 'center',
          customSlot: true,
          isResize: true,
        },
        {
          field: 'targetFileName',
          title: 'Output File Name',
          width: 700,
          columnAlign: 'left',
          titleAlign: 'center',
          customSlot: true,
          isResize: true,
        },
      ],
      titleRows: [
        [
          {
            fields: ['INDEX'],
            title: this.$t('tbl.common.columnNo'),
            titleAlign: 'center',
          },
          {
            fields: ['senderId'],
            title: 'Sender',
            titleAlign: 'center',
            orderBy: '',
          },
          {
            fields: ['recipientId'],
            title: 'Receiver',
            titleAlign: 'center',
            orderBy: '',
          },
          {
            fields: ['messageName'],
            title: 'Message',
            titleAlign: 'center',
            orderBy: '',
          },
          { fields: ['direction'], title: 'Direction', titleAlign: 'center' },
          {
            fields: ['transactionCode'],
            title: 'Status',
            titleAlign: 'center',
          },
          // 2022.04.15 213960 SPKA-444 Add column in Search result of Transaction Log
          {
            fields: ['recvTimestamp'],
            title: 'Received Date',
            titleAlign: 'center',
          },
          {
            fields: ['transTimestamp'],
            title: 'Translation Date',
            titleAlign: 'center',
          },
          {
            fields: ['sentTimestamp'],
            title: 'Sent Date',
            titleAlign: 'center',
          },
          {
            fields: ['fileLink'],
            title: 'Processed File',
            titleAlign: 'center',
          },
          { fields: ['processId'], title: 'Process ID', titleAlign: 'center' },
          {
            fields: ['searchKeyValue'],
            title: 'Search Key Value',
            titleAlign: 'center',
          },
          {
            fields: ['transInputSize'],
            title: 'Source File Size',
            titleAlign: 'center',
          },
          {
            fields: ['transOutputSize'],
            title: 'Target File Size',
            titleAlign: 'center',
          },
          {
            fields: ['processSetupName'],
            title: 'Setup Name',
            titleAlign: 'center',
          },
          {
            fields: ['bizFileBackupId'],
            title: 'Biz. File',
            titleAlign: 'center',
          },
          {
            fields: ['sourceFileName'],
            title: 'Input File Name',
            titleAlign: 'center',
          },
          {
            fields: ['targetFileName'],
            title: 'Output File Name',
            titleAlign: 'center',
          },
        ],
      ],
      listData: [],
      editedIndex: -1,
      statuses: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'PROCESSING', value: 'PROCESSING' },
        { text: 'SENT', value: 'DONE' },
        { text: 'ERROR', value: 'ERROR' },
      ],
      directions: [
        { text: this.$t('lbl.common.conditionSearch.all'), value: '' },
        { text: 'INBOUND', value: 'I' },
        { text: 'OUTBOUND', value: 'O' },
      ],
      EDIMesList: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }],
      searchByItems: [
        { text: this.$t('lbl.common.searchTypePlaceHolder'), value: 'all' },
        { text: 'Sender', value: 'senderId' },
        { text: 'Receiver', value: 'recipientId' },
        { text: 'Message', value: 'messageName' },
        { text: 'Partner', value: 'partnerId' },
        { text: 'Setup Name', value: 'processSetupName' },
      ],
      // 2021.10.11 203728 SPKA-234 add processId
      searchKeyByItems: [
        { text: 'Process ID', value: 'processId' },
        { text: 'Input Filename', value: 'inputFileName' },
        { text: 'Output Filename', value: 'outputFileName' },
      ],
      fromDateData: getAppliedTimeZone(),
      fromDate: false,
      fromTimeData: '00:00',
      fromTime: false,
      toDateData: getAppliedTimeZone(),
      toDate: false,
      toTimeData: '23:59',
      toTime: false,
      company: null, // 2021.6.10 163189 SKPA-134: Remove default
      userId: '',
      gmtTmzn: '',
      partner: '',
      senderId: '',
      recipientId: '',
      status: null, // 2021.6.10 163189 SKPA-134: Remove default
      direction: null, // 2021.6.10 163189 SKPA-134: Remove default
      message: null,
      processSetupName: null, // 2021.6.10 163189 SKPA-134: Remove default,
      processSetupId: null, // 2021.6.10 163189 SKPA-134: Remove default,
      messageReferenceId: '',
      messageDirecion: '',
      proTitle: '',
      processData: {},
      tmpInputFileLink: '',
      tmpOutputFileLink: '',
      tmpOutputBizFileLink: '',
      tmpItem: [],
      tempDataInfo: [],
      searchBy: 'all',
      searchByTxt: '',
      searchKeyBy1: 'processId', // 2021.10.11 203728 SPKA-234 set processId to default
      searchKeyBy2: '',
      page: 1,
      pageEnter: 1, // 2021.11.23 203728 SPKA-260 input value page number
      pageCount: 0,
      isFilter: false,
      isAddFilter: false,
      itemsPerPage: 100,
      rowPerPage: [
        { value: 10, text: 'Show 10' },
        { value: 25, text: 'Show 25' },
        { value: 50, text: 'Show 50' },
        { value: 75, text: 'Show 75' },
        { value: 100, text: 'Show 100' },
      ],
      compOrgList: [],
      customerItem: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }], // 2021.3.23 203728 SPKA-56
      processSetupNameList: [{ text: this.$t('lbl.common.conditionSearch.all'), value: '' }],
      hash: '',
      checkDialogColor: 'success',
      checkDialogTitle: '',
      checkDialogInfo: '',
      allSrchKeyList: [],
      isLoading: true,
      dataInfo: {},
      dataSort: {},
      // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
      rowCurrentClick: -1,
      rowKey: '',
      listFrozen: [
        'checkbox',
        'INDEX',
        'senderId',
        'recipientId',
        'messageName',
        'partnerName',
        'direction',
        'transactionCode',
        'recvTimestamp',
        'transTimestamp',
        'sentTimestamp',
        'fileLink',
        'processId',
        'searchKeyValue',
        'transInputSize',
        'transOutputSize',
        'processSetupName',
        'bizFileBackupId',
        'sourceFileName',
        'targetFileName',
      ],
      // 2021.9.17 203728 change to history version popup
      excelWarningContent: '',
      paramSearch: {},
      selectItems: [],
      checkReprocess: true,
      reProcessContent: '',
      selectReprocess: [],
    };
  },

  computed: {
    ...mapState('common', {
      CommMsgList: 'CommMsgList',
      sysloadingTitle: 'sysloadingTitle',
    }),
    getProcessSetupNameList() {
      return this.processSetupNameList;
    },
    getMaxDate() {
      return getAppliedTimeZone();
    },
    getMinDate() {
      return this.fromDateData;
    },
  },

  watch: {
    listData() {
      return this.listData;
    },
    page() {
      this.pageEnter = this.page;
    },
    model(val, prev) {
      if (val.length === prev.length) return;

      this.model = val.map((v) => {
        if (typeof v === 'string') {
          v = {
            text: v,
            color: this.colors[this.nonce - 1],
          };

          this.items.push(v);

          this.nonce++;
        }

        return v;
      });
    },
  },

  // mounted() {
  //   let cookieExists = this.$cookies.get("allowPopup");
  //   console.log(cookieExists);
  //   if (!cookieExists) this.$refs.checkallowPopup.dialog = true;
  // },

  methods: {
    removeChip(data, index) {
      data.splice(index, 1);
    },
    // changeCookie(item) {
    //   this.checkboxValue = item;
    // },
    // checkPopupCookie() {
    //   if (this.checkboxValue) {
    //     this.$cookies.set("allowPopup", this.checkboxValue);
    //   }
    // },
    displaySearchConditions(action) {
      if (action === 'expand') {
        $('.date-query-section').css('display', 'block');
        $('.data-query-section').css('display', 'block');
        $('.expand-search-conditions').css('display', 'none');
        $('.collapse-search-conditions').css('display', 'block');
      } else {
        $('.date-query-section').css('display', 'none');
        $('.data-query-section').css('display', 'none');
        $('.expand-search-conditions').css('display', 'block');
        $('.collapse-search-conditions').css('display', 'none');
      }
    },
    validateTimeInput(side) {
      let timeString = side === 'from' ? this.fromTimeData : this.toTimeData;
      var isValid = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(timeString);
      if (!isValid) {
        this.$refs.validateDate.dialog = true;
        side === 'from' ? (this.fromTimeData = '00:00') : (this.toTimeData = '23:59');
      }
    },
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateString.match(regEx)) return false; // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0, 10) === dateString;
    },
    formatDate(side, evt) {
      let dateString = side === 'from' ? this.fromDateData : this.toDateData;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else if (
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 4 &&
          !dateString.includes('-')) ||
        (charCode !== 46 &&
          charCode !== 8 &&
          charCode !== 45 &&
          dateString.length === 7 &&
          dateString[4] === '-' &&
          (dateString.match(/-/g) || []).length == 1)
      ) {
        dateString += '-';
        side === 'from' ? (this.fromDateData = dateString) : (this.toDateData = dateString);
      } else {
        return true;
      }
    },
    formatTime(side, evt) {
      let timeString = side === 'from' ? this.fromTimeData : this.toTimeData;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45 &&
        charCode !== 58
      ) {
        evt.preventDefault();
      } else if (
        charCode !== 46 &&
        charCode !== 8 &&
        charCode !== 58 &&
        timeString.length === 2 &&
        !timeString.includes(':')
      ) {
        timeString += ':';
        side === 'from' ? (this.fromTimeData = timeString) : (this.toTimeData = timeString);
      } else {
        return true;
      }
    },
    changeDate(side) {
      if (side === 'from') {
        if (!this.validateDateInput(this.fromDateData)) {
          this.$refs.validateDate.dialog = true;
          this.fromDateData = getAppliedTimeZone();
          this.toDateData = getAppliedTimeZone();
          return;
        }
        if (this.fromDateData > getAppliedTimeZone()) {
          this.fromDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.toDateData = this.fromDateData;
        }
      }
      if (side === 'to') {
        if (!this.validateDateInput(this.toDateData)) {
          this.$refs.validateDate.dialog = true;
          this.toDateData = getAppliedTimeZone();
          this.fromDateData = getAppliedTimeZone();
          return;
        }
        if (this.toDateData > getAppliedTimeZone()) {
          this.toDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.fromDateData = this.toDateData;
        }
      }
    },
    selectAll(selection) {
      this.selectItems = selection;
      if (this.selectItems.length == 0) {
        this.checkReprocess = true;
      } else {
        this.checkReprocess = false;
      }
    },
    selectChange(selection, rowData) {
      this.selectItems = selection;
      this.selectReprocess = selection;
      // this.selectReprocess = selection.filter(
      //   (e) =>
      //     this.statusText(e.transactionCode, e.reprocessState, e.processCode).indexOf(
      //       "Processing"
      //     ) == -1
      // );

      if (this.selectItems.length == 0) {
        this.checkReprocess = true;
      } else {
        this.checkReprocess = false;
      }
      // this.checkReprocess = false;
      // this.checkReprocess =
      //   selection.length > 0
      //     ? selection.some((e) =>
      //         this.statusText(e.transactionCode, e.reprocessState, e.processCode).includes(
      //           "Processing"
      //         )
      //       )
      //     : true;
    },
    async downOriginMulti() {
      const data = [];
      const _self = this;
      await Promise.all(
        _self.selectItems.map(async (e) => {
          const inputFilePath = `${e.record.transInput.fileLink}`;
          const originFileName = `${e.data.payload.userData.fileName}`;
          await _self.$store.dispatch('getinputFileContens', inputFilePath).then(() => {
            if (_self.$store.getters.inputFileContents != null) {
              let rslt = _self.convertFollowMessage(_self.$store.getters.inputFileContents);
              return data.push({ result: rslt, title: originFileName });
            }
          });
        }),
      );

      if (data.length > 1) {
        this.zipFiles(data);
      } else if (data.length == 1) {
        this.downloadFileView(data[0].result, data[0].title);
      }
    },
    convertFollowMessage(input) {
      let replace = '';
      if (input.match(/^ISA\*/g)) {
        replace = input.replace(/~/g, '~\n');
      } else if (input.match(/^UNB\+/g) || input.match(/^\s*(?:UNA.{5}')?/g)) {
        replace = input.replace(/'/g, "'\n");
      } else {
        replace = input.replace(/'/g, '\n');
      }
      return replace;
      // return replace.replace(/\n\n/g, "\n");
    },
    downloadFileView(content, title) {
      var data = new Blob([content], { type: 'text/plain' });
      var url = window.URL.createObjectURL(data);

      var a = document.createElement('a');
      a.href = url;
      a.download = title;
      document.body.appendChild(a);
      a.click();
    },
    async zipFiles(data) {
      var JSZip = require('jszip');
      const zip = new JSZip();
      data.map((e) => {
        const file1 = new Blob([e.result], { type: 'text/plain' });
        zip.file(e.title, file1);
      });

      const content = await zip.generateAsync({ type: 'blob' });
      this.saveAs(content, 'OriginFiles.zip');
    },
    saveAs(content, fileName) {
      const a = document.createElement('a');
      const isBlob = content.toString().indexOf('Blob') > -1;
      let url = content;
      if (isBlob) {
        url = window.URL.createObjectURL(content);
      }
      a.href = url;
      a.download = fileName;
      a.click();
      if (isBlob) {
        window.URL.revokeObjectURL(url);
      }
    },
    reProcesMulti() {
      this.$store
        .dispatch('execReTranslation', {
          data: this.selectItems.map((e) => e.data),
        })
        .then(() => {
          this.reProcessContent = 'ReTranslation is complete.';
          this.$refs.reProcess.dialog = true;
        });
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
    // 2022.2.9 203728 Call get map for History Workflow
    getMapList() {
      const masterSearchItems = {
        header: ['ADMIN_YN', 'CUST_ID'],
        data: [
          {
            ADMIN_YN: this.$cookies.get('user-admin-yn'),
            CUST_ID: this.$cookies.get('comp-id'),
          },
        ],
      };
      Store.dispatch('map/queryMapListByProcSetup', masterSearchItems);
    },
    // 2021.11.23 203728 SPKA-260 process change page by input textbox
    changePageByTextbox(value) {
      let data = parseInt(this.pageEnter);
      if (isNaN(data)) {
        this.pageEnter = this.page;
        return;
      } else {
        this.page = data > this.pageCount ? this.pageCount : data < 1 ? 1 : data;
        this.pageEnter = this.page;
      }
      this.page += value;
      this.initialize('pageChange');
    },
    // 2021.10.11 203728 SPKA-234 add removeSpaceCommo
    removeSpaceCommo(inputString) {
      inputString = inputString.replace(/\s/g, '').replace(/,,/g, '');
      if (inputString.substr(inputString.length - 1) == ',')
        inputString = inputString.substring(0, inputString.length - 1);
      return inputString;
    },
    // 2021.9.89 203728 SPKA-199 Change background when hover,click row in v-table
    rowClick(rowIndex, rowData) {
      this.listFrozen.map((e) => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
      this.rowCurrentClick = rowIndex;
      this.rowKey = rowData.processId;
    },
    rowEnter(rowIndex) {
      this.listFrozen.map((e) => {
        $('#' + e + rowIndex).addClass('custom-row-click-v-table');
      });
    },
    rowLeave(rowIndex) {
      if (this.rowCurrentClick !== rowIndex) {
        this.listFrozen.map((e) => {
          $('#' + e + rowIndex).removeClass('custom-row-click-v-table');
        });
      }
    },
    // 2021.7.27 203728 SPKA-162 Function sort (Accept only sender, recipient, message)
    sortChange(data) {
      // 2021.7.30 203728 Strore sort data
      this.dataSort = data;
      let keys = Object.keys(data);
      for (let i = 0; i < keys.length; i++) {
        let col = keys[i];
        let sort = data[col];
        if (sort != '') {
          Store.commit('sortmonitoringList', { col, sort });
          this.listData = this.$store.getters.monitoringList;
          // 2021.9.9 203728 SPKA-199 Change background when hover,click row in v-table
          // Clear current row by library
          this.$refs.srm_list_table.clearCurrentRow();
          // Clear row select of previous sort
          this.columns.map((e) => {
            $('#' + e.field + this.rowCurrentClick).removeClass('custom-row-click-v-table');
          });
          let index = this.listData.findIndex((e) => e.processId === this.rowKey);
          if (index > -1) {
            // Change row select of current sort
            this.rowCurrentClick = index;
            this.columns.map((e) => {
              $('#' + e.field + index).addClass('custom-row-click-v-table');
            });
          }
          return;
        }
      }
    },
    setSearchKeyByTxt(item) {
      var inputString = item;
      inputString = inputString.replace(/\r/g, '');
      inputString = inputString.replace(/\n+/g, '\n');
      inputString = inputString.replace(/^\n|\n$/g, '');
      inputString = inputString.replace(/\n/g, ',');

      inputString = this.removeSpaceCommo(inputString);
      this.searchKeyByTxt = inputString;
    },
    // 2021.9.17 203728 change to history version popup
    openProcessWindow(item) {
      const isHistory = true;
      const type = 'History';

      // 2021.9.16 203728 split processSetupId
      let processArray = item.processSetupId.split('-');
      let versionNo = 0.1;
      if (processArray.length > 1) {
        versionNo = processArray[1] / 10;
      }

      const params = {
        ROWID: processArray[0].toString(),
        type: type,
        options: {
          dataValue: processArray[0],
          id: processArray[0].toString(),
          isHistory: isHistory,
          versionNo: versionNo.toString(),
          fromTransaction: true,
        },
      };
      item.id = processArray[0];
      const arrView = {
        item,
        type,
      };
      const url = `/process/workflowDetailNew/${type}/${params.ROWID}/${params.options.versionNo}`;
      const size = 'width=1800,height=930,left=60,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },

    handlePageChange(value) {
      this.page = value;
      this.initialize('pageChange');
    },

    handlePageSizeChange(size) {
      this.itemsPerPage = size;
      this.page = 1;
      this.initialize();
    },
    initialize(pageChange) {
      this.selectItems = [];
      this.selectReprocess = [];

      this.listFrozen.map((e) => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
      });
      // 203737 05/11/2021 SPKA-98 issue 53 Fix spiner when search list again
      this.isLoading = true;
      this.searchKeyByTxt = this.removeSpaceCommo(this.searchKeyByTxt);
      if (
        dateValidation(deleteDateFormatStr(this.fromDateData), deleteDateFormatStr(this.toDateData))
      ) {
        // 2021.11.10 203728 SPKA-245 set Search params
        this.paramSearch = this.getParamData(pageChange);
        if (!this.paramSearch.dateCond && this.paramSearch.srchKeyVal == '') {
          this.isLoading = false;
          this.$refs.Validation.dialog = true;
          this.checkDialogColor = 'validation';
          this.checkDialogTitle = 'Search';
          this.checkDialogInfo = this.$t('msg.common.searchConditionValidate');
        } else {
          this.$store
            .dispatch('getMonitoringList', this.paramSearch)
            .then(() => {
              this.listData = this.$store.getters.monitoringList;
              //2021.11.22 203728 if total % items = 0
              if (this.$store.getters.totalCnt % this.itemsPerPage === 0) {
                this.pageCount = this.$store.getters.totalCnt / this.itemsPerPage;
              } else {
                this.pageCount = Math.floor(this.$store.getters.totalCnt / this.itemsPerPage) + 1;
              }
              if (pageChange == 'pageChange' && this.pageCount < this.page) {
                this.page = 1;
              }
              // this.createPageList(this.pageCount);
              this.searchByTxt = '';
              this.searchBy = 'all';
              this.onFilterTransactionLog();
              // 2021.7.30 203728 create index
              this.listData.map((e, i) => (e.INDEX = (this.page - 1) * this.itemsPerPage + i + 1));
              // 203728 - hide progress when expired time.
              this.isLoading = false;
            })
            .catch((ex) => {
              this.isLoading = false;
            });
        }
      } else {
        this.isLoading = false;
        this.$refs.Validation.dialog = true;
        this.checkDialogColor = 'validation';
        this.checkDialogTitle = 'Search';
        this.checkDialogInfo = this.$t('msg.common.fromDateValidate');
      }
    },
    getParamData(pageChange) {
      const params = {};
      this.userId = this.$cookies.get('user-id');
      this.gmtTmzn = this.$cookies.get('gmt-timezone');
      params.ownrId = this.$cookies.get('ownr-id');
      params.groupId = this.$cookies.get('comp-id');
      params.company = this.company == undefined || this.company == null ? '' : this.company; // 2021.6.10 163189 SKPA-134: Remove default,
      params.userId = this.userId;
      params.senderId = this.senderId;
      params.recipientId = this.recipientId;
      params.partner = this.partner;
      params.message = this.message == undefined || this.message == null ? '' : this.message.trim(); // 2021.6.10 163189 SKPA-134: Remove default,
      params.status = this.status == undefined || this.status == null ? '' : this.status; // 2021.6.10 163189 SKPA-134: Remove default,
      params.fromDateData = this.applyGmtTimeZoneForSrchcond(
        this.fromDateData + ' ' + this.fromTimeData,
      );
      params.toDateData = this.applyGmtTimeZoneForSrchcond(this.toDateData + ' ' + this.toTimeData);
      params.processSetupId =
        this.processSetupId == undefined || this.processSetupId == null ? '' : this.processSetupId; // 2021.6.10 163189 SKPA-134: Remove default,
      params.messageReferenceId = this.messageReferenceId;
      params.messageDirection =
        this.direction == undefined || this.direction == null ? '' : this.direction; // 2021.6.10 163189 SKPA-134: Remove default,
      params.srchKey1 =
        this.searchKeyBy1 == undefined || this.searchKeyBy1 == null ? '' : this.searchKeyBy1; // 2021.6.10 163189 SKPA-134: Remove default,
      params.srchKeyVal1 = this.chips1.join(',') || ''; // 2021.6.10 163189 SKPA-134: Remove default,
      params.srchKey2 =
        this.searchKeyBy2 == undefined || this.searchKeyBy2 == null ? '' : this.searchKeyBy2;
      params.srchKeyVal2 = this.chips2.join(',') || '';
      params.dateCond = this.dateCond;
      // 05/18/2021 203737 SPKA-109 issue 61 Add direction in search condition of called API for Transaction Log
      params.direction =
        this.direction == undefined || this.direction == null ? '' : this.direction; // 2021.6.10 163189 SKPA-134: Remove default,

      if (typeof pageChange == 'undefined' || pageChange != 'pageChange') {
        this.page = 1;
      }
      params.page = this.page;
      params.perPage = this.itemsPerPage;

      return params;
    },
    checkEditData(formData, loadFormData) {
      let keyArr = Object.keys(loadFormData);
      let checkEdit = false;
      for (let i = 0; i < keyArr.length; i++) {
        if (formData[keyArr[i]] !== loadFormData[keyArr[i]]) {
          checkEdit = true;
          break;
        }
      }
      return checkEdit;
    },

    // 2021.11.4 203728 SPKA-245 Get data for transaction excel
    // 2021.11.9 203728 SPKA-245 Modify condtion search
    // 2021.11.10 203728 SPKA-245 excel validation
    downloadExcel() {
      let param = this.getParamData();
      // case 1 : click the excel button without click "Search." --> "Please search first and try again."
      if (this.checkEditData(param, this.paramSearch)) {
        this.$refs.excelValidation.dialog = true;
        this.excelWarningContent = 'Please search first and try again.';
        return;
      }
      // case 2 : click the excel button even if there is no data in the grid. --> "There is no data to download. Pleae try again after search data."
      if (this.listData.length === 0) {
        this.$refs.excelValidation.dialog = true;
        this.excelWarningContent =
          'There is no data to download. Pleae try again after search data.';
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch('getMonitoringExcelData', this.paramSearch)
        .then((res) => {
          this.generateExcelFile(res);
          this.isLoading = false;
        })
        .catch((ex) => {
          this.isLoading = false;
        });
    },
    // 2021.11.4 203728 SPKA-245 Create excel
    generateExcelFile(excelData) {
      let self = this;
      const excel = require('node-excel-export');

      // You can define styles as json object
      const styles = {
        headerDark: {
          fill: {
            fgColor: {
              rgb: 'FF496D94',
            },
          },
          font: {
            color: {
              rgb: 'FFFFFFFF',
            },
            sz: 14,
          },
        },
      };

      // Sender ID	Receiver ID	  Msg Type	    Msg Status	      Rcv Date	      Trans Date	    Sent Date	      Search Key Value	Input File Size	  Output File Size	Source File Name	  Target File Name
      // senderId	  recipientId	  messageName	  transactionCode	  recvTimestamp	  transTimestamp	sentTimestamp	  searchKeyValue	  inputFileSize	    outputFileSize	  sourceFileName	    targetFileName
      // 110        110           110           120               180             180             180             250               110               110               700                 700

      //Here you specify the export structure
      const specification = {
        senderId: {
          // <- the key should match the actual data key
          displayName: 'Sender ID', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        recipientId: {
          // <- the key should match the actual data key
          displayName: 'Receiver ID', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        messageName: {
          // <- the key should match the actual data key
          displayName: 'Msg Type', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        transactionCode: {
          // <- the key should match the actual data key
          displayName: 'Msg Status', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          // cellFormat: function(value, row) { // <- Renderer function, you can access also any row.property
          //   let item = self.srmStatusArr.find((item) => { return item.value == value})
          //   return item ? item.text : '';
          // },
          width: 120, // <- width in pixels
        },
        recvTimestamp: {
          // <- the key should match the actual data key
          displayName: 'Rcv Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        transTimestamp: {
          // <- the key should match the actual data key
          displayName: 'Trans Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        sentTimestamp: {
          // <- the key should match the actual data key
          displayName: 'Sent Date', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        // item.processId;
        processId: {
          // <- the key should match the actual data key
          displayName: 'Process ID', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 180, // <- width in pixels
        },
        searchKeyValue1: {
          // <- the key should match the actual data key
          displayName: 'Search Key Value', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 250, // <- width in pixels
        },
        searchKeyValue2: {
          // <- the key should match the actual data key
          displayName: 'Search Key Value', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 250, // <- width in pixels
        },
        inputFileSize: {
          // <- the key should match the actual data key
          displayName: 'Input File Size', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        outputFileSize: {
          // <- the key should match the actual data key
          displayName: 'Output File Size', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 110, // <- width in pixels
        },
        sourceFileName: {
          // <- the key should match the actual data key
          displayName: 'Source File Name', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 700, // <- width in pixels
        },
        targetFileName: {
          // <- the key should match the actual data key
          displayName: 'Target File Name', // <- Here you specify the column header
          headerStyle: styles.headerDark, // <- Header style
          width: 700, // <- width in pixels
        },
      };

      // Create the excel report.
      // This function will return Buffer
      const report = excel.buildExport([
        // <- Notice that this is an array. Pass multiple sheets to create multi sheet report
        {
          name: 'Report', // <- Specify sheet name (optional)
          heading: [], // <- Raw heading array (optional)
          merges: [], // <- Merge cell ranges
          specification: specification, // <- Report specification
          data: excelData, // <-- Report data
        },
      ]);

      var data = new Blob([report.buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var url = window.URL.createObjectURL(data);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'Transaction_log.xlsx';
      document.body.appendChild(a);
      a.click();
    },

    addDays(date, days) {
      let result = moment(date)
        .add(days, 'd')
        .format('YYYY-MM-DD');
      return result;
    },

    applyGmtTimeZone(date) {
      let newM = '';
      if (date !== undefined && date !== '') {
        newM = moment(date)
          .add(this.gmtTmzn, 'hours')
          .format('YYYY-MM-DD HH:mm:ss');
      }
      return newM;
    },

    applyGmtTimeZoneForSrchcond(date) {
      let newM = '';
      let timezone = Number(this.gmtTmzn[1] + this.gmtTmzn[2]);
      if (date !== undefined && date !== '') {
        if (this.gmtTmzn.indexOf(`+`) === 0) {
          newM = moment(date)
            .subtract(timezone, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
        }
        if (this.gmtTmzn.indexOf(`-`) === 0) {
          newM = moment(date)
            .add(timezone, 'hours')
            .format('YYYY-MM-DD HH:mm:ss');
        }
      }
      return newM;
    },

    closeFileView() {
      this.dialogFileView = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    statusColor(status, processCode) {
      if (status.indexOf('SEND_O_DONE') !== -1 && processCode == 'finalDestination')
        return '#497DDE';
      else if (status.indexOf('FAIL') !== -1) return '#FF7B7A';
      else if (status.indexOf(undefined) !== -1) return '#FF7B7A';
      else return '#5BC5F1';
    },

    statusText(status, reprocessState, processCode) {
      let reProcSts = '';
      if (reprocessState === 'S') reProcSts = ' (Re-Send)';
      else if (reprocessState === 'T') reProcSts = ' (Re-Trans)';

      if (status.indexOf('SEND_O_DONE') !== -1 && processCode == 'finalDestination')
        return `Sent${reProcSts}`;
      else if (status.indexOf('FAIL') !== -1) return `Error${reProcSts}`;
      else if (status.indexOf(undefined) !== -1) return `Unknown${reProcSts}`;
      else return `Processing${reProcSts}`;
    },

    directionText(direction) {
      if (direction === 'I') return 'Inbound';
      else if (direction === 'O') return 'Outbound';
    },

    weekdayColor(a) {
      let week = new Date(a).getDay();

      if (week == 0) {
        return 'Sun';
      } else if (week == 1) {
        return 'Mon';
      } else if (week == 2) {
        return 'Tue';
      } else if (week == 3) {
        return 'Wed';
      } else if (week == 4) {
        return 'Thu';
      } else if (week == 5) {
        return 'Fri';
      } else if (week == 6) {
        return 'Sat';
      }
    },
    openMonitoringDateValidationWindow() {
      let type = 'dialogWindow';
      let item = {
        ROWID: 0,
      };
      let indexArrDialog = this.findDialog('openMonitoringDateValidationWindow_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    openMonitoringFileViewWindow(item) {
      const isHistory = true;
      const type = 'ProcessedFile';

      const params = {
        ROWID: item.processId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.processId.toString(),
        },
      };

      item.id = item.processId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringFileView/${type}/${params.ROWID}`;
      const size = 'width=1100,height=812,left=250,top=20';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    openMonitoringBizFileViewWindow(outputBizFileLink, rowItem) {
      let type = 'monitoringBizFileViewWindow';
      this.tmpOutputBizFileLink = outputBizFileLink;
      this.tempItem = rowItem;
      let item = {
        ROWID: 0,
        data: rowItem,
      };
      let indexArrDialog = this.findDialog('monitoringBizFileViewWindow_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    // 2022.02.10 SPKA-404 Modify Transaction Log Search Condition "Apply Date Condition"
    changeDateTime() {
      if (this.dateCond) {
        this.fromDateData = getAppliedTimeZone();
        this.fromTimeData = '00:00';
        this.toDateData = getAppliedTimeZone();
        this.toTimeData = '23:59';
      } else {
        this.fromDateData = '';
        this.fromTimeData = '';
        this.toDateData = '';
        this.toTimeData = '';
      }
    },
    changeKeyBy() {
      if (this.searchKeyBy !== 'processId') {
        this.checkSearchKeyBy = true;
        if (!this.dateCond) {
          this.dateCond = true;
          this.changeDateTime();
        }
      } else {
        this.checkSearchKeyBy = false;
      }
    },
    openMonitoringStateViewWindow(item) {
      const type = 'StateView';
      const params = {
        ROWID: item.processId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.processId.toString(),
        },
      };
      item.id = item.processId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringStateView/${type}/${params.ROWID}`;
      const size = 'width=1200,height=725,left=120,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
        onMessage: (message) => {
          if (message.includes('open-state-file')) {
            this.openDataInformationFileViewWindow(
              JSON.parse(message.replace('open-state-file', '')),
            );
          }
        },
      });
    },
    openDataInformationFileViewWindow(item) {
      const type = 'FileView';
      const params = {
        ROWID: item.recordId.toString(),
        type: type,
        options: {
          dataValue: item,
          id: item.recordId.toString(),
        },
      };
      item.id = item.recordId;
      const arrView = {
        item,
        type,
      };
      const url = `/monitoring/monitoringDataInfoFileView/${type}/${params.ROWID}`;
      const size = 'width=1100,height=721,left=250,top=50';
      openWindow({
        arrView,
        url: url,
        params,
        size: size,
      });
    },
    openAddFilter() {
      this.isAddFilter = true;
    },
    deleteAddFilter() {
      this.searchKeyBy2 = '';
      this.chips2 = '';
      this.isAddFilter = false;
    },
    openInputSearchKeyWindow() {
      let type = 'inputSearchKeyWindow';
      this.searchKeyByTxt = this.removeSpaceCommo(this.searchKeyByTxt);
      this.tempItem = this.searchKeyByTxt.replace(/,/g, '\n');
      let item = {
        ROWID: 0,
        data: this.searchKeyByTxt,
      };
      let indexArrDialog = this.findDialog('inputSearchKeyWindow_0');
      if (indexArrDialog != null) {
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    changeMsgCode() {
      // 2021.10.11 203728 SPKA-234 add processId
      this.searchKeyByItems = [
        { text: 'Process ID', value: 'processId' },
        { text: 'Input Filename', value: 'inputFileName' },
        { text: 'Output Filename', value: 'outputFileName' },
      ];
      if (!this.message) {
        this.searchKeyBy = 'processId';
        this.searchKeyByTxt = '';
        this.changeKeyBy();
        let getUniqueListBy = function(arr, key) {
          return [...new Map(arr.map((item) => [item[key], item])).values()];
        };
        let arr1 = getUniqueListBy(this.allSrchKeyList, 'srchKeyItem');
        arr1 = arr1.sort(function(a, b) {
          return b.srchKeyItem < a.srchKeyItem ? 1 : -1;
        });
        for (let i = 0; i < arr1.length; i++) {
          let SKeyObj = {};
          SKeyObj.text = arr1[i].srchKeyItem;
          SKeyObj.value = arr1[i].srchKeyItem;
          this.searchKeyByItems.push(SKeyObj);
        }
      } else {
        for (let i = 0; i < this.allSrchKeyList.length; i++) {
          let SKeyObj = {};
          if (this.allSrchKeyList[i].msgCd === this.message) {
            SKeyObj.text = this.allSrchKeyList[i].srchKeyItem;
            SKeyObj.value = this.allSrchKeyList[i].srchKeyItem;
            this.searchKeyByItems.push(SKeyObj);
          }
        }
      }

      this.initialize();
    },
    getSearchKeyList() {
      let params = {
        srcSrchKeyItem: '',
        srcMsgCd: '',
      };

      this.$store.dispatch('getSearchKeyList', params).then(() => {
        this.allSrchKeyList = this.$store.getters.srchKeyList;
        this.changeMsgCode();
      });
    },
    getEDIMsgTypeList() {
      let commMsgSearchItems = {
        header: ['MSG_NM'],
        data: [
          {
            MSG_NM: '',
          },
        ],
      };
      Store.dispatch('common/getCommonMessageList', commMsgSearchItems).then(() => {
        console.log('--------- Finished to process MES ----------');
        for (let i = 0; i < this.CommMsgList.length; i++) {
          let EDIVerObj = {};
          EDIVerObj.text = this.CommMsgList[i].MSG_CD + ' (' + this.CommMsgList[i].MSG_NM + ')';
          EDIVerObj.value = this.CommMsgList[i].MSG_CD;
          this.EDIMesList.push(EDIVerObj);
        }
      });
    },

    onFilterTransactionLog(isFilter) {
      // 2021.9.9 203728 SPKA-199 Clear select row
      this.$refs.srm_list_table.clearCurrentRow();
      this.listFrozen.map((e) => {
        $('#' + e + this.rowCurrentClick).removeClass('custom-row-click-v-table');
      });
      this.rowCurrentClick = -1;
      this.isFilter = true;
      if (this.searchBy == 'all' && this.searchByTxt == '') {
        this.isFilter = false;
      }
      Store.commit('SET_STORE_TRANSACTION_LOG_FILTER', {
        filter: this.searchBy,
        str: this.searchByTxt,
      });
      this.listData = this.$store.getters.monitoringList;
      // 2021.7.30 203728 Sort after filter
      this.sortChange(this.dataSort);
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
    closeDialog() {
      this.$refs.Validation.dialog = false;
    },
  },
  created() {
    if (this.$route.query.theme === 'Dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
    this.dateTimeFormat = config.dateTimeFormat;
    this.hash = $cookies.get('hash');
    if (this.$route.query.processId) {
      this.dateCond = false;
      this.changeDateTime();
    }

    // 2021.3.23 203728 SPKA-56
    this.$store.dispatch('getCompanyList').then(() => {
      console.log('--------- Finished to process Customer List ----------');
      this.$store.getters.companies.forEach((element) => {
        let codeObj = {};
        codeObj.text = element.compNm;
        codeObj.value = element.compId;
        this.customerItem.push(codeObj);
      });
    });
    // 05/17/2021 SPKA-111 issue 53 Fix spiner when call api error
    this.$store
      .dispatch('getProcessSetupList')
      .then(() => {
        const tmpProcessSetupList = this.$store.getters.processSetupList;
        for (let i = 0; i < tmpProcessSetupList.length; i += 1) {
          const tmpProcessSetup = tmpProcessSetupList[i];
          const tmp = {
            text: tmpProcessSetup.processSetupName,
            value: tmpProcessSetup.processSetupId,
          };
          this.processSetupNameList.push(tmp);
        }
      })
      .catch((ex) => {
        this.isLoading = false;
      });

    this.getEDIMsgTypeList();
    this.getSearchKeyList();
    this.initialize();
    this.getMapList();
    this.isCreated = true;
  },

  // 2021.7.27 203728 SPKA-162 Get height by int
  // 2021.11.23 203728 SPKA-260 add paging bottom
  updated: function() {
    let self = this;
    let arrClassMinus = ['.page-control-content'];
    let arrClassPlus = [];

    if (this.isCreated) {
      self.tableHeight = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      this.isCreated = false;
    }

    $(window).resize(function(event) {
      self.tableHeight = resizeTableHeight(arrClassMinus, arrClassPlus, true);
    });
  },
};
</script>

<style></style>
